module.exports = __webpack_public_path__ + "static/step-2.4c71999f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quickstart/layout/step-2.png
// module id = 2567
// module chunks = 152352670890342